// extracted by mini-css-extract-plugin
export default {"badge":"XSAZiEJXjqQBLcIl6Jfh","noContent":"dmVQ3eK0lPX_xatdNzJA"};